export const OPTIONS_MAP = {
  ALL: 0,
  ONGOING: 1,
  UPCOMING: 2
};

export const OPTIONS = [
  { label: 'All', value: OPTIONS_MAP.ALL },
  { label: 'Ongoing', value: OPTIONS_MAP.ONGOING },
  { label: 'Upcoming', value: OPTIONS_MAP.UPCOMING }
];

export const tabsData = [
  {
    id: 1,
    name: 'About'
  },
  {
    id: 3,
    name: 'Physical Notes'
  },
  {
    id: 2,
    name: 'Digital PDF Notes'
  },
  {
    name: 'Tests'
  },
  {
    id: 4,
    name: 'FAQs'
  }
];

export const SCROLL_OFFSET_TOP = 140;

export const TAB_INDICES = {
  FIRST_INDEX: 0,
  SECOND_INDEX: 1,
  THIRD_INDEX: 2,
  FOURTH_INDEX: 3,
  FIFTH_INDEX: 4
};

export const BLOCK_TYPE = {
  PHYSICAL: 'physical_notes',
  DIGITAL: 'digital_notes',
  TEST_SERIES: 'test_series',
  ABOUT: 'combo_details',
  FAQS: 'faqs'
};

export const contentBlockType = {
  physical_notes: 'Physical Notes',
  digital_notes: 'Digital Notes',
  test_series: 'Test Series'
};

export const DELIVERY_STATUS = {
  ADD_ADDRESS: 1,
  TRACK_ORDER: 2,
  VIEW_ORDER_DETAILS: 3
};

export const BlockTypeToLabel = {
  physical_notes: 'Physical Notes',
  digital_notes: 'Digital PDF Notes',
  test_series: 'Test Series',
  combo_details: 'About',
  faqs: 'FAQs'
};

export const modalHeadings = {
  numberOfBooks: 'No. of books',
  subjects: 'Subjects',
  authors: 'Authors',
  languages: 'Language',
  isbn13: 'ISBN-13',
  yearOfPublication: 'Year of publication'
};

export const BUNDLE_BUNDLE_VIEWED = 'Bundle - Bundle Viewed';

export const BUNDLE_SEE_ALL_CLICKED = 'Bundle - See All Clicked';

export const BUNDLE_BROCHURE_DOWNLOADED = 'Bundle - Brochure Downloaded';

export const NOTES_TOPIC_GROUP_SELECTED = 'Notes - Topic Group Selected';

export const contentType = {
  502: 'Digital Notes',
  400: 'Physical Notes',
  501: 'Test Series'
};
